import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-6 pb-8 sm:pt-12 sm:pb-20 items-center justify-center bg-bg-main overflow-hidden" data-id="element-275">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.15) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-276"></div>

      <div className="relative bg-badge-red/10 border border-badge-red/20 text-badge-red font-bold text-[10px] sm:text-xs px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-4 sm:mb-6 flex items-center gap-1.5 sm:gap-2" data-id="element-277">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-badge-red animate-pulse-composited" data-id="element-278"></span>
        <span className="hidden sm:inline" data-id="element-279">
          ATTENZIONE: DOCENTI DI MATEMATICA DI SCUOLA SECONDARIA STANCHI DI
          SACRIFICARE LE PROPRIE SERATE A PIANIFICARE
        </span>
        <span className="sm:hidden" data-id="element-280">
          ATTENZIONE: DOCENTI DI MATEMATICA SECONDARIA
        </span>
      </div>

      <h1 className="relative font-black text-text-main max-w-5xl sm:text-5xl md:text-7xl sm:leading-[1.05] mb-4 sm:mb-6 tracking-tight text-[30px] leading-[1.1]" data-id="element-281">
        L'intero anno di{' '}
        <span className="relative inline-block" data-id="element-282">
          <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-r from-primary via-orange-400 to-secondary" data-id="element-283">
            Matematica Secondaria
          </span>
          <span aria-hidden="true" className="absolute left-0 right-0 bottom-0.5 sm:bottom-1 h-2 sm:h-3 bg-primary/25 -z-0 rounded-sm" data-id="element-284"></span>
        </span>
        ,<br className="hidden sm:block" data-id="element-285" />{' '}
        <span className="text-text-main" data-id="element-286">pronto in</span>{' '}
        <span className="text-secondary" data-id="element-287">5 minuti</span>.
      </h1>

      <p className="relative text-text-sec text-sm sm:text-xl font-medium leading-relaxed mb-4 sm:mb-8 max-w-3xl mx-auto sm:bg-bg-alt sm:border sm:border-white/10 sm:border-l-4 sm:border-l-primary sm:px-8 sm:py-5 sm:rounded-r-xl sm:text-left" data-id="element-288">
        Il primo Kit{' '}
        <span className="text-orange-400 font-bold" data-id="element-289">"Apri e Insegna"</span> con
        8 volumi completi e lezioni pronte per Medie e Superiori.{' '}
        <span className="hidden sm:inline text-text-main font-semibold" data-id="element-290">
          Recupera i tuoi weekend e stupisci i tuoi alunni.
        </span>
      </p>

      <div className="relative w-full max-w-[260px] sm:max-w-[420px] md:max-w-[500px] mx-auto mb-4 sm:mb-8" data-id="element-291">
        <div className="absolute inset-0 rounded-full pointer-events-none" style={{
        background: 'radial-gradient(circle, rgba(234,88,12,0.15) 0%, transparent 70%)'
      }} aria-hidden="true" data-id="element-292"></div>
        <img src="https://cdn.magicpatterns.com/uploads/atmHyCXCYdpVMzEuqECSXU/1500-CLIENTE-SODDISFATTI-_3_.webp" alt="Matematica Pronta — Kit Scuola Secondaria" className="relative w-full h-auto object-contain rounded-2xl" width={500} height={500} sizes="(max-width: 640px) 260px, (max-width: 768px) 420px, 500px" fetchPriority="high" data-id="element-293" />
      </div>

      <div className="relative flex flex-col items-center gap-2 sm:gap-2 mb-4 sm:mb-6" data-id="element-294">
        <div className="flex items-center gap-2" data-id="element-295">
          <span className="text-secondary text-sm sm:text-lg" data-id="element-296">⭐⭐⭐⭐⭐</span>
          <span className="text-text-sec text-xs sm:text-base font-medium" data-id="element-297">
            4.9/5 (+800 Recensioni Verificate)
          </span>
        </div>
        <span className="text-secondary font-bold text-xs sm:text-sm bg-secondary/10 px-3 py-1 rounded-full border border-secondary/20" data-id="element-298">
          🔥 84 insegnanti hanno scelto questo Kit oggi
        </span>
      </div>

      <a href="#pricing" onClick={e => {
      const target = document.getElementById('pricing');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }} className="btn-cta btn-primary-pulse text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-5 inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-center" data-id="element-299">
        <span className="relative z-10" data-id="element-300">
          🚀 SÌ! VOGLIO RECUPERARE IL MIO TEMPO
        </span>
      </a>

      <p className="relative text-text-sec text-[11px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap" data-id="element-301">
        <span data-id="element-302">⚡ Accesso Immediato</span>
        <span data-id="element-303">•</span>
        <span data-id="element-304">🛡️ Garanzia 14 Giorni</span>
        <span data-id="element-305">•</span>
        <span data-id="element-306">💳 Pagamento Unico</span>
      </p>
    </section>;
}